import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { AuthService } from '../../_services/auth.service';
import { SharedService } from '../../_services/shared.service';
import { Observable, Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DepartmentResDto } from '../../_dtos/departmentResDto';
import { DepartmentsService } from '../../_services/departments.service';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatedToastService } from '../../_services/translated-toast.service';
import { UserResDto } from '../../_dtos/userResDto';
import { ServerFormData } from '../../_models/serverFormData';
import { ServersService } from '../../_services/servers.service';
import { ServerReqDto } from '../../_dtos/serverReqDto';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-order-form-server',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    MatOption,
    MatButton,
    CommonModule,
    MatTooltip,
    TranslateModule,
  ],
  providers: [DatePipe],
  templateUrl: './order-form-server.component.html',
  styleUrl: './order-form-server.component.css',
})
export class OrderFormServerComponent {
  private destroy$ = new Subject<void>();
  public department!: DepartmentResDto;
  public serverForm!: FormGroup;
  public departmentShortName!: string;
  public endDate!: Date;
  filteredPeople?: Observable<UserResDto[]>;

  protected versions = [
    { label: 'Windows Server 2022', value: 'win2022' },
    { label: 'Windows Server 2025', value: 'win2025' },
  ];

  constructor(
    private authService: AuthService,
    private toastr: TranslatedToastService,
    private sharedService: SharedService,
    private departmentsService: DepartmentsService,
    private serversService: ServersService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.getDataFromSharedService();
    this.setEndDate();
    this.initializeForm();
  }

  async onSubmit() {
    if (this.serverForm.valid) {
      const formValues = this.serverForm.getRawValue();

      const username = this.authService.getUsername();
      const serverRequestDto: ServerReqDto = {
        primaryOwner: username,
        osVersion: formValues.osVersion,
        function: formValues.function,
        department: formValues.department,
      };

      this.sharedService.closeModal();
      await this.toastr.show(
        'success',
        'TOASTS.SERVER.SUBMIT_TITLE',
        undefined,
      );

      this.serversService.saveServerData(serverRequestDto).subscribe({
        next: async (serverRes) => {
          await this.toastr.show(
            'success',
            'TOASTS.SERVER.ORDER_MESSAGE',
            'TOASTS.SERVER.ORDER_TITLE',
            { serverName: serverRes.serverName },
          );
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeForm() {
    this.serverForm = new FormGroup<ServerFormData>({
      osVersion: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      primaryOwner: new FormControl(
        { value: this.authService.getDisplayName(), disabled: true },
        { nonNullable: true },
      ),
      function: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      department: new FormControl(
        { value: this.department.name, disabled: true },
        { nonNullable: true },
      ),
      endDate: new FormControl(
        {
          value: this.datePipe.transform(this.endDate, 'dd.MM.yyyy') ?? '',
          disabled: true,
        },
        { nonNullable: true },
      ),
    });
  }

  private getDataFromSharedService() {
    this.department = this.departmentsService.getDepartment();
  }

  private setEndDate() {
    this.endDate = new Date();
    this.endDate.setDate(this.endDate.getDate() + 365);
  }
}
